const state = {
  dataLogin: {},
  dataRegisterAuth: {
    telp: "",
    password: "",
    nama: "",
  },
  dataOtpAuth: {
    telp: "",
    country_code: "62",
  },
  dataOtpForgotAuth: {},
  dataRegis: {},
  dataPasswordChange: {},

  dataOtpGanti: "",
};

export default state;
